module.exports = __webpack_public_path__ + "img/06-JS-check-your-resume.5ab9292f.svg";